/**
 * jewelx-validation.js
 * Inline form validation for the Jewelx ring configurator.
 * No browser alerts — shows a styled message box and scrolls to it.
 */

document.addEventListener('DOMContentLoaded', () => {

  const form       = document.querySelector('form[data-type="add-to-cart-form"]');
  const messageBox = document.getElementById('jewelx-validation-message');

  if (!form || !messageBox) return;

  /* ── SHOW / HIDE ── */

  function showMessage(html) {
    messageBox.innerHTML = html;
    messageBox.classList.add('show');
    messageBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearMessage() {
    messageBox.innerHTML = '';
    messageBox.classList.remove('show');
  }

  /* ── AUTO-CLEAR when the customer makes any selection ── */

  document.querySelectorAll(
    '.jewelx-shape, .jewelx-metal, .jewelx-color, ' +
    '.jewelx-clarity, .jewelx-carat, .jewelx-ring-size'
  ).forEach(function (btn) {
    btn.addEventListener('click', clearMessage);
  });

/* ── SUBMIT GUARD ── */

const submitButton = form.querySelector('.product-form__submit');

submitButton.addEventListener('click', function (e) {

  const data    = new FormData(form);

  // Require only the fields whose sections actually rendered (set by Liquid).
  // Hidden sections (Shape on composite/cluster rings, Carat/Color/Clarity on
  // no-center-stone designs) are absent from this list, so they never block.
  const req = window.JEWELX_REQUIRED ||
              ['Shape','Metal','Color','Clarity','Carat','Ring Size'];
  const missing = req.filter(function (f) {
    return !data.get('properties[' + f + ']');
  });

  if (missing.length === 0) {
    clearMessage();
    return;
  }

  e.preventDefault();
  e.stopImmediatePropagation();

  showMessage(
    '<strong>Please complete your selection:</strong><br>' +
    missing.map(function (item) { return '&bull;&nbsp;' + item; }).join('<br>')
  );

});

});
